import UserActions from "../Types";

const initialState = {
    isSendingMail: false,
    mailSentSuccess: false,
    mail: {},
    isSendingNewPassword: false,
    newPasswordSuccess: false,
    newPassword: {},
    error: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case UserActions.USER_RESET_PASSWORD_START:
            return {
                ...state,
                isSendingMail: true,
                mailSentSuccess: false,
                error: null
            }
        case UserActions.USER_RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                isSendingMail: false,
                mailSentSuccess: true,
                mail: action.payload,
                error: null
            }
        case UserActions.USER_RESET_PASSWORD_FAILURE:
            return {
                ...state,
                isSendingMail: false,
                mailSentSuccess: false,
                error: action.payload
            }
        case UserActions.USER_SEND_NEW_PASSWORD_START:
            return {
                ...state,
                isSendingNewPassword: true,
                newPasswordSuccess: false,
                error: null
            }
        case UserActions.USER_SEND_NEW_PASSWORD_SUCCESS:
            return {
                ...state,
                isSendingNewPassword: false,
                newPasswordSuccess: true,
                newPassword: action.payload,
                error: null
            }
        case UserActions.USER_SEND_NEW_PASSWORD_FAILURE:
            return {
                ...state,
                isSendingNewPassword: false,
                newPasswordSuccess: false,
                error: action.payload
            }
        case UserActions.CLEAR_RESET_PASSWORD_STATE:
            return initialState;
        default:
            return state;
    }
}